
  import { AxiosResponse } from "axios";
  import { defineComponent } from "vue";
  import { get } from "lodash";

  import { CardAppearances } from "@/components/base-card/CustomTypes";
  import BaseProcessComponentV2 from "@/components/processComponents/v2/BaseProcessComponentV2.vue";
  import DocumentCard from "@/components/DocumentCard.vue";
  import documentsTableConfig from "@/core/config/DocumentsTableConfig";
  import Drivers from "@/helpers/clients/Drivers";
  import ThePagination from "@/components/ThePagination.vue";

  const driversClient = new Drivers();

  export default defineComponent({
    name: "DmClientProductDocumentsV2",

    components: { DocumentCard, ThePagination },

    extends: BaseProcessComponentV2,

    data() {
      return {
        errorMessage: null as string | null,
        currentPage: 1 as number,
        items: [] as any[],
        isLoading: false as boolean,
        record: null as any | null,
        tableConfig: documentsTableConfig as any,
      };
    },

    computed: {
      appearance(): string {
        return CardAppearances.row;
      },

      paginatedItems(): any[] {
        const pageSize = 12;

        const start = (this.currentPage - 1) * pageSize;
        const end = start + pageSize;

        return this.items.slice(start, end);
      },
    },

    async created() {
      try {
        this.isLoading = true;
        this.record = await this.getRecord(
          get(this, "applicationStore.application.custom_attributes.vividocs.client_product.id", "")
        );

        this.items = await this.getItems({
          clientProductId: this.record.id,
          folders: get(this.record, "product.folders"),
          excludeSettings: get(this, "settings.attributes.exclude", []),
        });
      } catch (error) {
        this.errorMessage = "No se encontró en ViviDocs un expediente que coincida";
      } finally {
        this.isLoading = false;
      }
    },

    methods: {
      changePage(event: any) {
        this.currentPage = event.selectedPage;
      },

      async getRecord(clientProductId: string): Promise<any> {
        const response: AxiosResponse = await driversClient.execute(
          get(this, "settings.attributes.proxy_driver.id", ""),
          {
            method: "read",
            resource: "ClientProducts",
            arguments: {
              client_product_id: clientProductId,
            },
          }
        );

        return response.data;
      },

      async getItems({
        clientProductId,
        folders,
        trail = [],
        excludeSettings = [],
      }: {
        clientProductId: string;
        folders: any[];
        trail?: string[];
        excludeSettings?: string[];
      }): Promise<any> {
        const results = await Promise.all(
          folders
            .filter((folder: any) => {
              return !excludeSettings
                .includes(
                  [folder.path, `${folder.type}_id:${folder.id}`]
                    .filter(Boolean)
                    .join("|"),
                );
            })
            .map(async (folder) => {
              const currentTrail = [...trail, folder.name];

              if (folder.folders?.length) {
                return this.getItems({
                  clientProductId: clientProductId,
                  folders: folder.folders,
                  trail: currentTrail,
                  excludeSettings: excludeSettings,
                });
              }

              const response = await driversClient.execute(get(this, "settings.attributes.proxy_driver.id", ""), {
                resource: "ClientProducts",
                method: "get_folder_documents",
                arguments: {
                  client_product_id: clientProductId,
                  folder_id: folder.id,
                  filters: {
                    path: folder.path,
                  },
                },
              });

              return response.data.results.map((document: any) => ({
                folderId: folder.id,
                folderPath: folder.path,
                document,
                trail: currentTrail,
              }));
            })
        );

        return results.flat();
      },

      titleClasses(title: any): string {
        return `${title.colClasses} ${title.headerClasses}`;
      },
    },
  });
